import { plugin_registry } from 'nk-plugin-registry';

import "generics/scrollToTopButton";

plugin_registry.init();